"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwnReflectMetadata = getOwnReflectMetadata;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
function getOwnReflectMetadata(target, metadataKey, propertyKey) {
    return Reflect.getOwnMetadata(metadataKey, target, propertyKey);
}
//# sourceMappingURL=getOwnReflectMetadata.js.map